var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-6"},[_c('v-card',[_c('v-card-title',[_vm._v("\n\t\t\tОтчеты\n\t\t\t"),_c('v-spacer')],1),_c('a-data-table',{attrs:{"headers":_vm.headers,"api-path":"logs/get_report","disable-sort":""},scopedSlots:_vm._u([{key:"item.time",fn:function(ref){
var item = ref.item;
return [_vm._v("\n\t\t\t\t"+_vm._s(item.timeFormatted)+"\n\t\t\t")]}},{key:"item.execTime",fn:function(ref){
var item = ref.item;
return [_vm._v("\n\t\t\t\t"+_vm._s(item.execTime)+" мс\n\t\t\t")]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }